// Initialize Sentry + Mixpanel analytics
import 'analytics';
import ChakraProvider from 'ui/Provider';

import ApiProvider from './ApiProvider';
import AppEnvironmentProvider from './AppEnvironmentProvider';
import AppRoutes from './AppRoutes';
import CurrentUserProvider from './CurrentUserProvider';
import MediaQueryProvider from './MediaQueryProvider';
import OAuthProviders from './OAuthProviders';
import TeamProvider from './TeamProvider';

const App: React.FC = () => (
  <AppEnvironmentProvider>
    <ChakraProvider>
      <MediaQueryProvider>
        <OAuthProviders>
          <ApiProvider>
            <CurrentUserProvider>
              <TeamProvider>
                <AppRoutes />
              </TeamProvider>
            </CurrentUserProvider>
          </ApiProvider>
        </OAuthProviders>
      </MediaQueryProvider>
    </ChakraProvider>
  </AppEnvironmentProvider>
);

export default App;
